const regs = {
  phone: {
    reg: /^1[3,4,5,7,8,9]\d{9}$/,
    msg: '手机号码格式错误',
    nil: '请填写手机号码'
  },
  email: {
    reg: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
    msg: '邮箱格式错误',
    nil: '请填写邮箱'
  },
  verify: {
    reg: /^\d{6}$/,
    msg: '验证码格式错误',
    nil: '请填写验证码'
  },
  password: {
    reg: /^[a-zA-Z0-9_!@#$%^&*?~-]{6,20}$/,
    msg: '格式6～20位数字、符号、英文字母',
    nil: '请填写密码'
  },
  nickname: {
    reg: /^[\u4e00-\u9fa5a-zA-Z0-9]{2,20}$/,
    msg: '格式2-20个字符的中文、英文、数字',
    nil: '请填写昵称'
  },
  username: {
    reg: /^[A-Za-z0-9]{4,20}$/,
    msg: '格式4-20个字符的英文、数字',
    nil: '请填写用户名'
  },
  cardNumber: {
    reg: /^[A-Za-z0-9]{14}$/,
    msg: '格式14个字符的英文、数字',
    nil: '请输入卡号'
  }
}

export default regs



// WEBPACK FOOTER //
// ./src/tools/regs.js